import React from "react";

import {
    CardTitle,
    Table,

} from "reactstrap";

import Format from '../../common/Format';

export default class SystemInfo extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            id_title: this.props.id_title ? this.props.id_title : '',
            id_value: this.props.id_value ? this.props.id_value : '',
            update_timestamp: this.props.update_timestamp ? this.props.update_timestamp : '',
            update_user: this.props.update_user ? this.props.update_user : '',
            update_user_picture: this.props.update_user_picture ? this.props.update_user_picture : '',
            visible: this.props.visible !== undefined ? this.props.visible : true
        };
    }

    componentDidUpdate(prevProps) {
        if (JSON.stringify(this.props) === JSON.stringify(prevProps))
            return;

        this.setState({
            id_title: this.props.id_title ? this.props.id_title : '',
            id_value: this.props.id_value ? this.props.id_value : '',
            update_timestamp: this.props.update_timestamp ? this.props.update_timestamp : '',
            update_user: this.props.update_user ? this.props.update_user : '',
            update_user_picture: this.props.update_user_picture ? this.props.update_user_picture : '',
            visible: this.props.visible !== undefined ? this.props.visible : true
        });
    }

    render() {
        return (
            <>
                {this.state.visible && (() => {
                    return (
                        <>
                            <CardTitle tag="h4">システム情報</CardTitle>
                            <Table>
                                <tbody>
                                    <tr>
                                        {/* <th rowSpan="2">システム情報</th> */}
                                        <td className="subTitle">{this.state.id_title}</td>
                                        <td>{this.state.id_value}</td>
                                        <td className="subTitle">最終更新日</td>
                                        <td>{Format.format_datetime(this.state.update_timestamp)}</td>
                                    </tr>
                                    <tr>
                                        <td className="subTitle">最終更新者</td>
                                        <td colSpan="3" className="text-left">
                                            <div className="photo">
                                                {this.state.update_user_picture && <img alt="..." src={this.state.update_user_picture} />}
                                            </div>{this.state.update_user}
                                        </td>
                                    </tr>
                                </tbody>
                            </Table>
                        </>
                    )
                })()}
            </>
        );
    }
}
